"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompletedComponent = void 0;
var react_1 = __importDefault(require("react"));
var CompletedComponent = function () {
    return react_1.default.createElement("div", { className: "flex justify-center" }, "Auction has completed! Thank you for participating!");
};
exports.CompletedComponent = CompletedComponent;
